<template>
  <SharedCredentialForm v-if="user" :user="user" :isEdit="true"/>
</template>

<script>
import store from "@/modules/Shared/Store/store";
import SharedCredentialForm from "@/modules/Admin/Components/SharedCredentials/SharedCredentialForm.vue";
import {parseUserScopedRolesFromAPI} from "@/modules/Admin/Helpers/userScopedRolesHelper";
import UsersService from "@/modules/Admin/Services/UsersService";
import AuthorizationService from "@/modules/Admin/Services/AuthorizationService";
import SharedCredentialsService from "@/modules/Admin/Services/SharedCredentialsService";

export default {
  name: "EditSharedCredentialPage",
  components: {SharedCredentialForm},

  data() {
    return {
      user: null
    }
  },
  async beforeRouteEnter (to, from, next) {
      const [user, sharedCredential, userScopedRoles] = await Promise.all([    
        UsersService.getUser(to.params.uuid),
        SharedCredentialsService.getSharedCredential(to.params.uuid),
        AuthorizationService.getUserScopedRoles(to.params.uuid)
      ])  

      user.credential = sharedCredential
      user.scoped_roles = parseUserScopedRolesFromAPI(userScopedRoles)

      await store.dispatch('setRouteElement', user)
      
      next(vm => vm.user = user)
  },
};
</script>
